import styled from 'styled-components';

export const Hr = styled.hr`
	border: 0;
	border-top: 0.5px solid ${({ theme }) => theme.colors.principal.eris};
`;
